import { z } from "zod";

/**
 * Audit + idempotency record for one automation rule firing on one event.
 *
 * The doc id is deterministic: `${ruleId}__${entityType}__${entityId}__${eventTs}`.
 * Cloud Function triggers are at-least-once; creating this doc inside a
 * transaction guarantees a rule runs at most once per event (a duplicate
 * delivery finds the doc already present and skips).
 */
export const AutomationExecutionSchema = z.object({
	id: z.string(),
	ruleId: z.string(),
	entityType: z.enum(["profile", "lead"]),
	entityId: z.string(),
	eventTs: z.number(),
	status: z.enum(["succeeded", "failed", "skipped"]),
	createdAt: z.number(),
	/** id of the doc the action produced (e.g. the created task) when succeeded. */
	resultRef: z.string().optional(),
	errorMessage: z.string().optional(),
});
export type TAutomationExecution = z.infer<typeof AutomationExecutionSchema>;

/** Build the deterministic execution doc id. Keep in sync with the engine. */
export function buildExecutionId(
	ruleId: string,
	entityType: "profile" | "lead",
	entityId: string,
	eventTs: number,
): string {
	return `${ruleId}__${entityType}__${entityId}__${eventTs}`;
}
